import { useQuery } from "react-query";
import { searchOfficeSettings } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetAllDarkOffices = () => {
  return useQuery(
    ["GetAllDarkOffices", { isOfficeDark: true }],
    searchOfficeSettings,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllDarkOffices;
